import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  '& a': {
    fontFamily: 'montserrat',
    color: theme.palette.primary.main,
  },
  '& hr': {
    border: 'none',
    height: 1,
    backgroundColor: theme.palette.global.lightgray,
  },
  '& h5': {
    color: theme.palette.global.white,
  },
  '& .links': {
    width: 165,
    display: 'flex',
    flexDirection: 'column',
    right: 1,
    '& p': {
      color: theme.palette.primary.main,
      fontFamily: theme.typography.body1.fontFamily,
      fontSize: 14,
      cursor: 'pointer',
    },
  },
  '& p': {
    color: theme.palette.global.lightgray,
    fontFamily: 'montserrat',
    fontSize: 14,
  },
}));

export const DivBlockStyled = styled('div')(({ theme }) => ({
  border: '1px solid #ccc',
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  '& + div': {
    backgroundColor: theme.palette.secondary.main,
    color: '#F2F2F2',
    border: 'none',
  },
  '&:hover': {
    backgroundColor: alpha('#ccc', 0.4),
    cursor: 'pointer',
  },
}));

export const SectionStyled = styled('section')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '16px 0',
});
